import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";

const LINKS = [
    { label: "What We Offer", href: "#packages" },
    { label: "FAQ", href: "#faq" },
    { label: "Our Turf", href: "#turf" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const go = (href) => {
        setOpen(false);
        document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    };
    return (
        <motion.header
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 90, damping: 16, delay: 0.2 }}
            className="fixed inset-x-0 top-0 z-50"
        >
            <div className="mx-auto mt-4 flex max-w-6xl items-center justify-between gap-4 rounded-full border-2 border-monster-navy bg-white/90 px-4 py-2.5 shadow-sticker-sm backdrop-blur-md sm:mx-4 lg:mx-auto">
                <button
                    data-testid="nav-logo"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="flex items-center gap-2.5"
                >
                    <img src="/logo.png" alt="Monsters Inflatables logo" className="h-11 w-11 rounded-full border-2 border-monster-navy object-cover" />
                    <span className="font-display text-lg font-semibold leading-none text-monster-navy">
                        Monsters <span className="text-monster-blue">Inflatables</span>
                    </span>
                </button>
                <nav className="hidden items-center gap-6 md:flex">
                    {LINKS.map((l) => (
                        <button
                            key={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                            onClick={() => go(l.href)}
                            className="font-display text-sm font-medium text-monster-navy/80 transition-colors hover:text-monster-blue"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>
                <div className="flex items-center gap-2">
                    <a
                        data-testid="nav-phone-link"
                        href="tel:+18104441076"
                        className="hidden items-center gap-2 rounded-full border-2 border-monster-navy bg-monster-yellow px-4 py-2 font-display text-sm font-semibold text-monster-navy shadow-sticker-sm transition-transform hover:-translate-y-0.5 lg:inline-flex"
                    >
                        <Phone className="h-4 w-4" /> (810) 444-1076
                    </a>
                    <button
                        data-testid="nav-book-now-btn"
                        onClick={() => go("#book")}
                        className="hidden rounded-full border-2 border-monster-navy bg-monster-blue px-5 py-2 font-display text-sm font-semibold text-white shadow-sticker-sm transition-transform hover:-translate-y-0.5 sm:block"
                    >
                        Book Now
                    </button>
                    <button
                        data-testid="nav-mobile-menu-btn"
                        onClick={() => setOpen(!open)}
                        className="rounded-full border-2 border-monster-navy bg-white p-2 md:hidden"
                        aria-label="Toggle menu"
                    >
                        {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                    </button>
                </div>
            </div>
            {open && (
                <div className="mx-4 mt-2 rounded-3xl border-2 border-monster-navy bg-white p-4 shadow-sticker md:hidden">
                    {LINKS.map((l) => (
                        <button
                            key={l.href}
                            data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                            onClick={() => go(l.href)}
                            className="block w-full rounded-xl px-4 py-3 text-left font-display font-medium text-monster-navy hover:bg-monster-sky"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-mobile-book-btn"
                        onClick={() => go("#book")}
                        className="mt-2 w-full rounded-full border-2 border-monster-navy bg-monster-blue px-4 py-3 font-display font-semibold text-white"
                    >
                        Book Now
                    </button>
                </div>
            )}
        </motion.header>
    );
};
